import { useNavigate } from "react-router-dom";
import ServiceForm from "./ServiceForm";
import Header from "./Header";
import desktop from "../assets/images/new_bp_form_desktop.webp";
import mobile from "../assets/images/new_bp_form_mobile.webp";
import "./FormPage.scss";

export default function FormPage() {
    const navigate = useNavigate();

    return (
        <>
            <Header/>
            <div className="main-container row-layout-template form-page">
                <div className="form-outer-container">
                    <div className="form-bg">
                        <ServiceForm onSuccess={() => navigate("/dziekujemy")}/>
                    </div>
                </div>
                <div className="main-image">
                    <img src={desktop} className="background-image" alt=""/>
                    <img src={mobile} className="background-image-mobile" alt=""/>
                </div>
            </div>
        </>
    );
}
